<button style="width: 30px;" mat-icon-button [disabled]="takingScreenShot" color="primary" (click)="takeScreenShotForVolume()"
        [matTooltip]="'GENERIC.SCREENSHOT' | translate"
        class="light_color m-2">
  <fa-icon style="font-size:18px;" [icon]="['far','print']"></fa-icon>
</button>
<mat-spinner *ngIf="takingScreenShot" style="display: inherit;" diameter="20" class="m-2"  ></mat-spinner>
